var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect4, _rect5, _path11, _ellipse, _rect6, _ellipse2, _ellipse3, _ellipse4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 96,
    viewBox: "0 0 80 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 61,
    width: 27,
    height: 3,
    rx: 1.5,
    fill: "#80C0FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 61,
    width: 16,
    height: 3,
    rx: 1.5,
    fill: "#80C0FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3134,
    y: 23.1941,
    width: 23.5075,
    height: 19.0299,
    fill: "#f54268"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7761 20.9552H67.1269L71.4179 42.2239H49.7761V20.9552Z",
    fill: "#559BDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7239 20.9552L69.3657 42.2239H47.7239V20.9552Z",
    fill: "#C9DDEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3397 18.8022H49.8285V16.1231C49.8285 15.0672 50.2315 14.0112 51.0337 13.209C51.8397 12.403 52.8919 12 53.9479 12H56.2165C57.2725 12 58.3285 12.403 59.1307 13.209C59.933 14.0149 60.336 15.0672 60.336 16.1231V18.8022H60.3397Z",
    fill: "#ff718f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9963 40.6791C76.959 40.2761 76.8956 39.8694 76.8023 39.4664C76.6456 38.7574 76.4068 38.0821 76.1083 37.4477L67.4665 19.1529C67.1344 18.4552 66.612 17.8395 65.9105 17.3918C65.209 16.9477 64.4292 16.7388 63.6568 16.7388H13.1941L8.19409 55.903H18.7389C18.7389 50.6828 22.9702 46.4552 28.1866 46.4552C33.4068 46.4552 37.6344 50.6828 37.6344 55.903H48.3172C48.3172 50.6828 52.5448 46.4552 57.765 46.4552C62.9851 46.4552 67.2127 50.6828 67.2127 55.903H77.0411V41.5858C77.0374 41.2873 77.0225 40.985 76.9963 40.6791ZM37.1866 35.9104H31.6904V41.4104H24.6792V35.9104H19.1829V28.9029H24.6792V23.4067H31.6904V28.9029H37.1866V35.9104ZM53.459 38.6604C53.0336 38.6604 52.612 38.5 52.2911 38.1791C51.9665 37.8544 51.8098 37.4328 51.8098 37.0112V23.5074C51.8098 23.1306 51.9516 22.75 52.2426 22.4627C52.5299 22.1791 52.9068 22.0298 53.2874 22.0298H61.7165C62.3247 22.0298 62.9404 22.2015 63.4851 22.5597C64.0336 22.9141 64.4329 23.4104 64.6754 23.9664L69.7799 35.6753C70.056 36.3134 70.0187 37.0709 69.6083 37.694C69.1978 38.3209 68.5187 38.6604 67.8247 38.6604H53.459Z",
    fill: "#E3EEF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1829 47.5895C23.5897 47.5895 19.8695 51.3134 19.8695 55.9066C19.8695 60.4962 23.5897 64.2201 28.1829 64.2201C32.7762 64.2201 36.4964 60.4962 36.4964 55.9066C36.4964 51.3096 32.78 47.5895 28.1829 47.5895ZM28.1829 59.2723C26.3247 59.2723 24.8173 57.7649 24.8173 55.9066C24.8173 54.0484 26.3247 52.541 28.1829 52.541C30.0411 52.541 31.5486 54.0484 31.5486 55.9066C31.5523 57.7649 30.0449 59.2723 28.1829 59.2723Z",
    fill: "#4576e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8807 47.5895C53.2874 47.5895 49.5673 51.3134 49.5673 55.9066C49.5673 60.4962 53.2874 64.2201 57.8807 64.2201C62.4702 64.2201 66.1941 60.4962 66.1941 55.9066C66.1941 51.3096 62.4702 47.5895 57.8807 47.5895ZM57.8807 59.2723C56.0225 59.2723 54.515 57.7649 54.515 55.9066C54.515 54.0484 56.0225 52.541 57.8807 52.541C59.7389 52.541 61.2464 54.0484 61.2464 55.9066C61.2501 57.7649 59.7426 59.2723 57.8807 59.2723Z",
    fill: "#4576e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97448 40.3583L8.35815 55.6418H18.9029C18.9029 50.4216 23.1343 46.194 28.3507 46.194C33.5708 46.194 37.7985 50.4216 37.7985 55.6418H48.4813C48.4813 50.4216 52.7089 46.194 57.9291 46.194C63.1492 46.194 67.3768 50.4216 67.3768 55.6418H77.2052V41.3246C77.2014 41.0261 77.1865 40.7239 77.1604 40.4179C77.1586 40.398 77.1566 40.3782 77.1547 40.3583H31.8544V41.1493H24.8432V40.3583H9.97448Z",
    fill: "#80C0FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1641 43.2761C78.1641 42.1492 77.6903 41.1791 77.0149 40.7313V45.8209C77.6903 45.3731 78.1641 44.4067 78.1641 43.2761Z",
    fill: "#FAD7B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7202 54.1754C78.7202 55.0858 77.9813 55.8246 77.0709 55.8246H69.6493C68.7388 55.8246 68 55.0858 68 54.1754L68.6791 50.6493C68.6791 49.7388 69.4179 49 70.3284 49H77.75C78.6605 49 79.3993 49.7388 79.3993 50.6493L78.7202 54.1754Z",
    fill: "#68A0D1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7201 54.1753C15.7201 55.0858 14.9813 55.8246 14.0709 55.8246H6.64925C5.73881 55.8246 5 55.0858 5 54.1753L5.5 50.6492C5.5 49.7387 6.23881 48.9999 7.14925 48.9999H14.5709C15.4813 48.9999 16.2201 49.7387 16.2201 50.6492L15.7201 54.1753Z",
    fill: "#68A0D1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 7.41418,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(-45 46 7.41418)",
    fill: "#ff718f"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54.4749,
    y: 3.97485,
    width: 2,
    height: 5,
    rx: 1,
    fill: "#ff718f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76 5C76 7.20914 72.1944 9 67.5 9C62.8056 9 59 7.20914 59 5C59 2.79086 60.3056 2.5 65 2.5C69.6944 2.5 76 2.79086 76 5Z",
    fill: "#F9F9F9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 3.5,
    rx: 5,
    ry: 3.5,
    fill: "#F9F9F9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 64.9497 7.41418)",
    fill: "#ff718f"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23,
    cy: 11.5,
    rx: 9,
    ry: 4.5,
    fill: "#F9F9F9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 6,
    rx: 12,
    ry: 6,
    fill: "#F9F9F9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 6,
    rx: 9,
    ry: 6,
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallDoc);
export default __webpack_public_path__ + "static/media/call_doc.af533a27e3ceec235a0b149f3d5303ca.svg";
export { ForwardRef as ReactComponent };